<!--Main-->
<div class="page-container" [class.loading]="isLoading">
    <app-header title="performance.overview.title" [menuService]="performanceMenuService">
        <div class="buttons">
            <ui-button
                (click)="trackCreatingGoal()"
                type="ghost"
                *permission="createGoalPermission"
                [routerLink]="['..', 'goals', 'create']"
            >
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'performance.overview.createGoal' | appTranslate }}
            </ui-button>
            <ui-button
                (click)="trackCreatingReview()"
                type="primary"
                *permission="createReviewPermission"
                [routerLink]="
                    !isPerformanceImprovementsFeatureFlagEnabled
                        ? ['..', 'reviews', 'create']
                        : ['..', 'reviews', 'create-bulk']
                "
            >
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'performance.overview.createReview' | appTranslate }}
            </ui-button>
        </div>
    </app-header>

    <div class="ui clear hidden double divider"></div>

    <div class="ui stackable grid">
        <div class="ten wide column">
            <div class="ui segment reviews" style="text-align: center" [class.loading]="isReviewsLoading">
                <app-segment-header title="performance.overview.performanceDashboard.label"></app-segment-header>
                <!--No reviews-->
                <div *ngIf="!hasReviews" class="empty">
                    <img class="margin-bottom-1" src="/assets/illustrations/clipboard-star.png" />
                    <h2 class="ui centered header">
                        {{ 'performance.overview.performanceDashboard.noReviewsMessage' | appTranslate }}
                        <div class="sub header" *permission="createReviewPermission">
                            <a style="margin-top: 1em; margin-bottom: 2em" [routerLink]="['..', 'reviews', 'create']">{{
                                'performance.overview.createReview' | appTranslate
                            }}</a>
                        </div>
                    </h2>
                </div>
                <ng-container *ngIf="hasReviews">
                    <div class="ui two column grid reviews">
                        <div class="column">
                            <div class="container">
                                <div class="ui statistic">
                                    <div class="value">{{ reviewStats.inProgress }}</div>
                                    <div class="label lettercase">
                                        {{ 'performance.overview.goalStatuses.inProgress' | appTranslate }}
                                    </div>
                                </div>
                            </div>

                            <div class="container">
                                <div class="ui statistic">
                                    <div class="value">{{ reviewStats.overdue }}</div>
                                    <div class="label lettercase">
                                        {{ 'performance.overview.goalStatuses.overdue' | appTranslate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="container">
                                <div class="ui statistic">
                                    <div class="value">{{ reviewStats.scheduled }}</div>
                                    <div class="label lettercase">
                                        {{ 'performance.overview.goalStatuses.scheduled' | appTranslate }}
                                    </div>
                                </div>
                            </div>

                            <div class="container">
                                <div class="ui statistic">
                                    <div class="value">{{ reviewStats.completed }}</div>
                                    <div class="label lettercase">
                                        {{ 'performance.overview.goalStatuses.completed' | appTranslate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <ui-button type="link" url="/performance/reviews">{{
                        'performance.overview.performanceDashboard.seeAllReviews' | appTranslate
                    }}</ui-button>
                </ng-container>
            </div>
        </div>

        <!-- Goal Graph -->
        <div class="six wide column">
            <div class="ui segment goals" [class.loading]="isGoalsLoading">
                <app-segment-header title="performance.overview.goalChart.label"></app-segment-header>
                <!--No goals-->
                <div *ngIf="!hasGoals" class="empty">
                    <img class="margin-bottom-1" src="/assets/illustrations/flag.png" />
                    <h2 class="ui centered header">
                        {{ 'performance.overview.performanceDashboard.noActiveGoals' | appTranslate }}
                        <div class="sub header" *permission="createGoalPermission">
                            <a style="margin-top: 1em; margin-bottom: 2em" [routerLink]="['..', 'goals', 'create']">{{
                                'performance.overview.createGoal' | appTranslate
                            }}</a>
                        </div>
                    </h2>
                </div>
                <!--Goals -->
                <ng-container *ngIf="hasGoals">
                    <canvas id="goalChart" style="width: 100%; height: 170px; margin-bottom: 50px"></canvas>
                    <div class="container">
                        <span
                            ><span
                                class="ui tiny circular empty label"
                                [ngStyle]="{ 'background-color': goalColors.inProgress }"
                            ></span>
                            {{ 'performance.overview.goalStatuses.inProgress' | appTranslate }}
                        </span>
                        <span class="goalCount">
                            {{
                                {
                                    key: 'performance.overview.goalChart.goalsIndicator',
                                    params: { goalCount: goalStats.inProgress },
                                } | appTranslate
                            }}
                        </span>
                    </div>
                    <div class="container">
                        <span
                            ><span
                                class="ui tiny circular empty label"
                                [ngStyle]="{ 'background-color': goalColors.completed }"
                            ></span>
                            {{ 'performance.overview.goalStatuses.completed' | appTranslate }}
                        </span>
                        <span class="goalCount">
                            {{
                                {
                                    key: 'performance.overview.goalChart.goalsIndicator',
                                    params: { goalCount: goalStats.completed },
                                } | appTranslate
                            }}
                        </span>
                    </div>
                    <div class="container">
                        <span
                            ><span
                                class="ui tiny circular empty label"
                                [ngStyle]="{ 'background-color': goalColors.scheduled }"
                            ></span>
                            {{ 'performance.overview.goalStatuses.scheduled' | appTranslate }}</span
                        >
                        <span class="goalCount">
                            {{
                                {
                                    key: 'performance.overview.goalChart.goalsIndicator',
                                    params: { goalCount: goalStats.scheduled },
                                } | appTranslate
                            }}
                        </span>
                    </div>
                    <div class="container">
                        <span
                            ><span
                                class="ui tiny circular empty label"
                                [ngStyle]="{ 'background-color': goalColors.overdue }"
                            ></span>
                            {{ 'performance.overview.goalStatuses.overdue' | appTranslate }}</span
                        >
                        <span class="goalCount">
                            {{
                                {
                                    key: 'performance.overview.goalChart.goalsIndicator',
                                    params: { goalCount: goalStats.overdue },
                                } | appTranslate
                            }}
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
